var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { UserClaimsService } from "../../services/authentication/user-claims.service";
import { DataType } from "../queries/queries.models";
import * as Enumerable from 'linq';
import { RouterConstants } from "../../configuration/router.constants";
import { LotteryPlatformClaims } from "../../constants/modules/lotteryplatform.claims";
export var TableColumnDataType;
(function (TableColumnDataType) {
    TableColumnDataType[TableColumnDataType["Text"] = 1] = "Text";
    TableColumnDataType[TableColumnDataType["Bit"] = 2] = "Bit";
    TableColumnDataType[TableColumnDataType["Integer"] = 3] = "Integer";
    TableColumnDataType[TableColumnDataType["Double"] = 4] = "Double";
    TableColumnDataType[TableColumnDataType["Color"] = 5] = "Color";
    TableColumnDataType[TableColumnDataType["Image"] = 6] = "Image";
    TableColumnDataType[TableColumnDataType["Date"] = 7] = "Date";
})(TableColumnDataType || (TableColumnDataType = {}));
export var DynamicColumnTypes;
(function (DynamicColumnTypes) {
    DynamicColumnTypes[DynamicColumnTypes["String"] = 1] = "String";
    DynamicColumnTypes[DynamicColumnTypes["DateTime"] = 2] = "DateTime";
    DynamicColumnTypes[DynamicColumnTypes["Bool"] = 3] = "Bool";
    DynamicColumnTypes[DynamicColumnTypes["Integer"] = 4] = "Integer";
    DynamicColumnTypes[DynamicColumnTypes["Double"] = 5] = "Double";
})(DynamicColumnTypes || (DynamicColumnTypes = {}));
export var EntityTypes;
(function (EntityTypes) {
    //Lottery Types
    EntityTypes[EntityTypes["None"] = 0] = "None";
    EntityTypes[EntityTypes["Lottery"] = 1] = "Lottery";
    EntityTypes[EntityTypes["Brand"] = 2] = "Brand";
    EntityTypes[EntityTypes["Player"] = 3] = "Player";
    EntityTypes[EntityTypes["Transaction"] = 4] = "Transaction";
    EntityTypes[EntityTypes["Operator"] = 5] = "Operator";
    EntityTypes[EntityTypes["WinningNominationClaim"] = 6] = "WinningNominationClaim";
    EntityTypes[EntityTypes["Bundle"] = 7] = "Bundle";
    EntityTypes[EntityTypes["Syndicate"] = 8] = "Syndicate";
    EntityTypes[EntityTypes["InstantGame"] = 9] = "InstantGame";
    EntityTypes[EntityTypes["InstantGamesWinningClaim"] = 10] = "InstantGamesWinningClaim";
    EntityTypes[EntityTypes["ApiSettings"] = 11] = "ApiSettings";
    EntityTypes[EntityTypes["Sweepstake"] = 12] = "Sweepstake";
    EntityTypes[EntityTypes["SweepstakeWinningClaim"] = 13] = "SweepstakeWinningClaim";
    //Genesis Types
    EntityTypes[EntityTypes["User"] = 1000] = "User";
    EntityTypes[EntityTypes["Branch"] = 1001] = "Branch";
    EntityTypes[EntityTypes["Department"] = 1002] = "Department";
    EntityTypes[EntityTypes["Role"] = 1003] = "Role";
    EntityTypes[EntityTypes["Permission"] = 1004] = "Permission";
    EntityTypes[EntityTypes["BranchPermission"] = 1005] = "BranchPermission";
    EntityTypes[EntityTypes["DepartmentPermission"] = 1006] = "DepartmentPermission";
    EntityTypes[EntityTypes["RolePermission"] = 1007] = "RolePermission";
    EntityTypes[EntityTypes["UserPermission"] = 1008] = "UserPermission";
    EntityTypes[EntityTypes["Dashboard"] = 1009] = "Dashboard";
    EntityTypes[EntityTypes["UserDashboard"] = 1010] = "UserDashboard";
    EntityTypes[EntityTypes["DashboardWidget"] = 1011] = "DashboardWidget";
    EntityTypes[EntityTypes["ActivityLog"] = 1012] = "ActivityLog";
    EntityTypes[EntityTypes["EventLog"] = 1013] = "EventLog";
    EntityTypes[EntityTypes["OnboardingRequest"] = 1014] = "OnboardingRequest";
    EntityTypes[EntityTypes["OnboardingConfig"] = 1015] = "OnboardingConfig";
    EntityTypes[EntityTypes["WorkflowConfiguration"] = 1016] = "WorkflowConfiguration";
})(EntityTypes || (EntityTypes = {}));
var PropertyChangeNotifier = /** @class */ (function () {
    function PropertyChangeNotifier() {
        this.state = {};
    }
    PropertyChangeNotifier.prototype.trigger = function () {
        if (this.state) {
            this.state = null;
        }
        else {
            this.state = {};
        }
    };
    return PropertyChangeNotifier;
}());
export { PropertyChangeNotifier };
var EntityTypeConfigurationHelper = /** @class */ (function () {
    function EntityTypeConfigurationHelper(userClaimsService) {
        this.userClaimsService = userClaimsService;
    }
    EntityTypeConfigurationHelper.prototype.getConfigurationWithoutPermissions = function (entityUriList, configuration) {
        if (configuration === void 0) { configuration = null; }
        return Enumerable.from(configuration && configuration.length > 0 ? configuration : AllEntityTypeConfigurationConstants)
            .where(function (x) { return entityUriList.length === 0 || Enumerable.from(entityUriList).contains(x.uri); })
            .toArray();
    };
    EntityTypeConfigurationHelper.prototype.getConfiguration = function (entityUriList, configuration) {
        var _this = this;
        if (configuration === void 0) { configuration = null; }
        return Enumerable.from(configuration && configuration.length > 0 ? configuration : AllEntityTypeConfigurationConstants)
            .where(function (x) { return entityUriList.length === 0 || Enumerable.from(entityUriList).contains(x.uri); })
            .where(function (x) { return entityUriList.length === 0 || _this.userClaimsService.hasPermissions(x.claims); })
            .toArray();
    };
    EntityTypeConfigurationHelper.prototype.getConfigurationForDashboard = function (entityUriList) {
        var _this = this;
        return Enumerable.from(AllEntityTypeConfigurationConstants)
            .where(function (x) { return entityUriList.length === 0 || Enumerable.from(entityUriList).contains(x.uri); })
            .where(function (x) { return !_this.userClaimsService.hasPermissions(x.exludeInDashboardIfWithClaims); })
            .where(function (x) { return entityUriList.length === 0 || _this.userClaimsService.hasPermissions(x.claims); })
            .toArray();
    };
    EntityTypeConfigurationHelper = __decorate([
        autoinject,
        __metadata("design:paramtypes", [UserClaimsService])
    ], EntityTypeConfigurationHelper);
    return EntityTypeConfigurationHelper;
}());
export { EntityTypeConfigurationHelper };
export var AllEntityTypeConfigurationConstants = [
    {
        title: "Lotteries",
        editRoute: RouterConstants.RouteNames.ManageLottery,
        uri: "Lotteries",
        entityType: EntityTypes.Lottery,
        isVisible: true,
        properties: "name",
        format: "{0}",
        claims: []
    }, {
        title: "BrandLotteries",
        editRoute: RouterConstants.RouteNames.ManageLottery,
        uri: "BrandLotteries",
        entityType: EntityTypes.Lottery,
        isVisible: true,
        properties: "name",
        format: "{0}",
        claims: []
    },
    {
        title: "Brands",
        editRoute: RouterConstants.RouteNames.ManageBrand,
        uri: "Brands",
        typeSingular: "Brand",
        entityType: EntityTypes.Brand,
        isVisible: true,
        properties: "name",
        format: "{0}",
        claims: []
    },
    {
        title: "Operators",
        editRoute: RouterConstants.RouteNames.ManageOperator,
        uri: "Operators",
        entityType: EntityTypes.Operator,
        isVisible: true,
        properties: "name",
        format: "{0}",
        claims: []
    },
    {
        title: "Players",
        editRoute: RouterConstants.RouteNames.ManagePlayer,
        uri: "Players",
        entityType: EntityTypes.Player,
        isVisible: true,
        properties: "playerId",
        format: "{0}",
        claims: []
    },
    {
        title: "Transaction Only",
        uri: "Transactions",
        entityType: EntityTypes.Transaction,
        isVisible: true,
        properties: "transactionId",
        format: "{0}",
        claims: []
    },
    {
        title: "Transaction with tickets",
        uri: "TransactionTicketDetails",
        entityType: EntityTypes.Transaction,
        isVisible: true,
        properties: "transactionId",
        format: "{0}",
        claims: []
    },
    {
        title: "Winning Nomination Claims",
        uri: "WinningNominationClaims",
        editRoute: RouterConstants.RouteNames.ManageWinningNominationClaim,
        entityType: EntityTypes.WinningNominationClaim,
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: []
    },
    {
        title: "Instant Games Winning Claims",
        uri: "InstantGamesWinningClaims",
        editRoute: RouterConstants.RouteNames.ManageInstantGameWinningClaim,
        entityType: EntityTypes.InstantGamesWinningClaim,
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: []
    },
    {
        title: "Ticket Lines",
        uri: "TicketLines",
        editRoute: RouterConstants.RouteNames.ManageTicketLine,
        isVisible: true,
        properties: "gamePlayerTicketLineId",
        format: "{0}",
        claims: []
    },
    {
        title: "Ticket Line Draws",
        editRoute: RouterConstants.RouteNames.ManageTicketDraw,
        uri: "TicketLineDraws",
        isVisible: true,
        properties: "gamePlayerTicketDrawId",
        format: "{0}",
        claims: []
    },
    {
        title: "Event Logs",
        uri: "EventLogs",
        entityType: null,
        fixedColumns: [
            {
                name: "select",
                title: "",
                dataType: DataType.Boolean,
                isHidden: false,
                sortOrder: 0,
                isFilterable: false,
                columnOrder: -1,
                isEditable: true,
                instancePerRow: true,
                value: null,
                width: "34px"
            }
        ],
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: [],
        navbar: true,
        editRoute: function (data, router) {
            router.navigateToRoute(data.item.resolveRoute);
        }
    }, {
        title: "Editor Logs",
        uri: "EditorLogs",
        entityType: null,
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: []
    },
    {
        title: "Billings",
        uri: "Billings",
        entityType: null,
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: [LotteryPlatformClaims.PlatformAdmin]
    },
    {
        title: "Processed Insurer Files",
        uri: "ProcessedInsurerFiles",
        entityType: null,
        isVisible: true,
        properties: "processedInsurerFileId",
        format: "{0}",
        claims: [LotteryPlatformClaims.PlatformAdmin]
    },
    {
        title: "Affiliate Link Analytics",
        uri: "AffiliateLinkAnalytics",
        entityType: null,
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: []
    },
    {
        title: "Api Settings",
        uri: "ApiSettings",
        typeSingular: "Api Setting",
        entityType: EntityTypes.ApiSettings,
        isVisible: true,
        properties: "name",
        format: "{0}",
        claims: [LotteryPlatformClaims.ManageApiSettings]
    },
    {
        title: "Sweepstakes",
        uri: "Sweepstakes",
        typeSingular: "Sweepstake",
        entityType: EntityTypes.Sweepstake,
        isVisible: true,
        properties: "name",
        format: "{0}",
        claims: [LotteryPlatformClaims.EditInstantGame]
    },
    {
        title: "Sweepstake Winning Claims",
        uri: "SweepstakeWinningClaims",
        editRoute: RouterConstants.RouteNames.ManageSweepstakeWinningClaim,
        entityType: EntityTypes.SweepstakeWinningClaim,
        isVisible: true,
        properties: "",
        format: "{0}",
        claims: []
    }
];
var BaseModal = /** @class */ (function () {
    function BaseModal(dialogClient) {
        this.dialogClient = dialogClient;
    }
    BaseModal.prototype.preventFromHidingModal = function (e) {
        e.stopPropagation();
    };
    BaseModal.prototype.hideModal = function (callback) {
        if (callback === void 0) { callback = null; }
        this.dialogClient.hide();
        callback();
    };
    return BaseModal;
}());
export { BaseModal };
export var ScheduledActionStatusEnum;
(function (ScheduledActionStatusEnum) {
    ScheduledActionStatusEnum[ScheduledActionStatusEnum["Pending"] = 1] = "Pending";
    ScheduledActionStatusEnum[ScheduledActionStatusEnum["Compleated"] = 2] = "Compleated";
    ScheduledActionStatusEnum[ScheduledActionStatusEnum["Rejected"] = 3] = "Rejected";
})(ScheduledActionStatusEnum || (ScheduledActionStatusEnum = {}));
